<template>
    <div id="unityEndPage" v-loading="loading">
        <div class="box">
            <div class="icon">
                <i class="el-icon-success"></i>
            </div>
            <div class="title">
                <h1>考试结束 您的考试成绩为:</h1>
                <div class="score">{{ result }}</div>
            </div>
            <div class="buttonGroup">
                <div class="row">
                    <el-button class="mainButton" type="primary" @click="goto('userCenter?unityExamId='+id)">查看详情</el-button>
                    <el-button @click="goto('userCenter')">返回用户中心</el-button>
                </div>            
                <el-button @click="closeWindow()">关闭</el-button>
            </div>
        </div>        
    </div>
</template>

<script>
export default {
    name: 'unityEndPage',
    data() {
        return {
            result:"",
            id:"",
            loading:false,
        }
    },
    methods: {
        async getResult(){
            this.loading = true;
            this.id = this.$route.query.id;
            let data = await this.$root.getUnityExamInfo(this.$route.query.id);
            if(data){
                this.result = data.exam_result;
            }            
            this.loading = false;
        },
        goto(url=""){
            if(url == ""){
                return false;
            }
            this.$router.replace(url);
        },
        closeWindow(){
            if (window.opener) {
                window.close();
            } else {
                this.$notify({
                    type: 'error',
                    title: '错误',
                    message: '关闭失败,请手动关闭窗口'
                });
            }
        }
    },
    created(){
        this.getResult();
        this.$root.showPost('期待您的反馈...');
    }
}
</script>

<style lang="scss" scoped src="@/assets/css/unityEndPage.scss"></style>